import { Box, Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";
import CustomTooltip from "./CustomTooltip";
import LoadingIcon from "./LoadingIcon";

const TimePointSelector = ({
  history,
  isLoadingHistory,
  selectedTimePoint,
  handleTimePointClick,
  loadingIconSize = 10,
  borderColor = null,
  backgroundColor = null,
  tooltipText = "View posture as it was on this specific day",
  gap = 2,
  padding = 0.5,
}) => {
  const colors = useColors();

  const defaultBorderColor = borderColor || colors.grey_100;
  const defaultBackgroundColor = backgroundColor || "transparent";

  return isLoadingHistory ? (
    <LoadingIcon size={loadingIconSize} />
  ) : (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap,
        maxWidth: "fit-content",
      }}
    >
      <Box
        display="flex"
        sx={{
          border: `1px solid ${defaultBorderColor}`,
          borderRadius: "8px",
          p: padding,
          alignItems: "center",
          backgroundColor: defaultBackgroundColor,
        }}
      >
        {Object.entries(history || {})?.map(([label, option]) => {
          const isDisabled = option === null;
          return (
            <CustomTooltip
              key={label}
              title={!isDisabled ? tooltipText : ""}
              placement="top"
            >
              <Box
                onClick={() => {
                  handleTimePointClick(label, option);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "4px 8px",
                  borderRadius: "8px",
                  cursor: isDisabled ? "default" : "pointer",
                  backgroundColor:
                    selectedTimePoint === label
                      ? colors.primary_8percent
                      : "transparent",
                  transition: "background-color 0.2s",
                  "&:hover": {
                    backgroundColor:
                      selectedTimePoint !== label && !isDisabled
                        ? colors.grey_100
                        : colors.primary_8percent,
                  },
                  opacity: isDisabled ? 0.5 : 1,
                  pointerEvents: isDisabled ? "none" : "auto",
                }}
              >
                <Typography
                  variant={selectedTimePoint === label ? "overline" : "caption"}
                  color={
                    selectedTimePoint === label
                      ? colors.primary_main
                      : colors.text_secondary
                  }
                >
                  {label}
                </Typography>
              </Box>
            </CustomTooltip>
          );
        })}
      </Box>
    </Box>
  );
};

export default TimePointSelector;
